var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.957 9.6875C20.6133 5.69141 17.4336 2.51172 13.4375 2.16797V9.6875H20.957ZM12.75 11.0625C12.3633 11.0625 12.0625 10.7617 12.0625 10.375V1.4375C12.0625 1.09375 12.3203 0.75 12.6641 0.75H12.75C18.0352 0.75 22.375 5.08984 22.375 10.375V10.4609C22.332 10.8047 22.0312 11.0625 21.6875 11.0625H12.75ZM9.01172 14.1133C8.75391 13.8555 8.625 13.5117 8.625 13.125V3.75781C4.67188 4.70312 1.75 8.22656 1.75 12.4375C1.75 17.3789 5.74609 21.375 10.6875 21.375C12.2773 21.375 13.7812 20.9453 15.1133 20.2148L9.01172 14.1133ZM9.26953 2.25391C9.65625 2.16797 10 2.51172 10 2.89844V13.125L16.7031 19.8711C17.0039 20.1719 16.9609 20.6445 16.6602 20.8594C14.9414 22.0625 12.8789 22.75 10.6875 22.75C4.97266 22.75 0.375 18.1523 0.375 12.4375C0.375 7.23828 4.24219 2.94141 9.26953 2.25391ZM20.0117 18.4961C21.043 17.3789 21.7734 16.0039 22.1172 14.5H16.0586L20.0117 18.4961ZM23.6211 13.8555V13.8984C23.3203 16.2617 22.1602 18.4102 20.4414 20C20.1836 20.2148 19.7969 20.2148 19.5391 19.957L13.9102 14.3281C13.4805 13.8984 13.7812 13.125 14.3828 13.125H22.9766C23.3633 13.125 23.707 13.4688 23.6211 13.8555Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplate);
export default __webpack_public_path__ + "static/media/icon_template.0705ebf662e20ab252f7be0091640c0a.svg";
export { ForwardRef as ReactComponent };